import { useSelector } from 'react-redux'

const useMarkets = () => {
  const { result, loaded, loading } = useSelector((state) => state.configurations)

  // Includes disabled markets; callers filter as needed.
  const markets = result?.Markets || []
  const defaultMarket = result?.DefaultMarket || markets.find((market) => market.IsDefault)?.Code
  const defaultOffice = result?.DefaultOffice || ''

  const getMarket = (code) => markets.find((market) => market.Code === code)
  const getMarketByOffice = (officeId) => markets.find((market) => market.OfficeId === officeId)

  return {
    defaultMarket,
    defaultOffice,
    getMarket,
    getMarketByOffice,
    loaded,
    loading,
    markets,
  }
}

export default useMarkets
